// Pop-up: the driver's plate photo for a tip.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { findPlatePhoto, fmtDate, fmtTime, toDriveEmbed, toDriveProxy } from './helpers.js';

export default function PhotoModal({ photoRow, refresh, setPhotoRow }) {
  return (
    <>
      {photoRow && (
        <div className="modal-backdrop" onClick={() => setPhotoRow(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 480, maxWidth: '90vw' }}>
            <h3>Plate — {photoRow.licensePlate}</h3>
            <div className="small" style={{ marginBottom: '0.5rem', color: '#666' }}>From driver's form submission on {fmtDate(photoRow.date)} {fmtTime(photoRow.arrivalTime)}</div>
            {(() => {
              const url = photoRow._resolvedPhoto || findPlatePhoto(photoRow);
              if (!url) {
                return <div style={{ padding: '2rem', textAlign: 'center', background: '#fef9c3', color: '#854d0e', borderRadius: 4 }}>
                  No photo on file for this row.
                </div>;
              }
              const proxy = toDriveProxy(url, photoRow._id);
              const embed = toDriveEmbed(url);
              return (
                <>
                  {proxy && (
                    <img src={proxy} alt={photoRow.licensePlate || 'plate'}
                         style={{ display: 'block', maxWidth: '100%', maxHeight: '70vh', margin: '0 auto', objectFit: 'contain' }}
                         onError={(e) => {
                           // Backend proxy failed (service account couldn't reach file or not configured).
                           // Hide the broken img and fall back to the Drive iframe embed below.
                           e.currentTarget.style.display = 'none';
                           const fb = document.getElementById('photo-modal-iframe-fb');
                           if (fb) fb.style.display = 'block';
                         }} />
                  )}
                  {embed && (
                    <iframe id="photo-modal-iframe-fb" src={embed} title={photoRow.licensePlate || 'plate'}
                            style={{ display: proxy ? 'none' : 'block', width: '100%', height: '70vh', border: 0 }}
                            allow="autoplay" />
                  )}
                  <div style={{ marginTop: '0.5rem', fontSize: '0.85em' }}>
                    <a href={url} target="_blank" rel="noreferrer">Open original in Google Drive ↗</a>
                  </div>
                </>
              );
            })()}
            <div style={{ marginTop: '1rem', textAlign: 'right' }}>
              <button className="refresh-btn" onClick={() => setPhotoRow(null)} style={{ background: '#888' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
